module.exports = __webpack_public_path__ + "static/media/CircleAdd.6c5f27d4.svg";